import _ from 'lodash'
import {store} from 'redux/store'
import {getCarrierList} from 'services/common.service'
import * as yup from 'yup'
import {CPS_OPTIONS_POST_LOGIN, CPS_OPTIONS_PRE_LOGIN, type ContactLoaderType} from './contactUs.constants'

// Loader Handler used for contact-us page to check the user authorization and return the initial values for the form
const ContactRouteLoader = async () => {
    const isAuthenticated = localStorage.getItem('isLoggedIn') === 'true'
    const initialValues = {
        carrier: '-Select-',
        issue: '-Select-',
        description: '',
        name: '',
        phone: '',
        countryCode: '1:United States',
        email: '',
        attachments: []
    }
    const finalData: ContactLoaderType = {
        initialValues,
        isAuthenticated,
        issueCPSOptions: isAuthenticated ? CPS_OPTIONS_POST_LOGIN : CPS_OPTIONS_PRE_LOGIN,
        carrierOptions: [],
        phoneCode: ''
    }
    try {
        const {data} = await getCarrierList({
            pageName: 'Contact page'
        })
        const sortedList = _.cloneDeep(data.response).sort((a, b) => a.displayName.localeCompare(b.displayName))
        const list = sortedList?.map((temp) => ({
            value: temp.name,
            label: `${temp.displayName} (${temp.name})`
        }))
        finalData.carrierOptions = [...list]
        if (isAuthenticated) {
            const user = store.getState().login?.loginDetails?.securityParams || {}
            const phoneNumber = user?.phone.substring(parseInt(user?.phone.indexOf(' ')) + 1)
            if (user?.phone.indexOf('+') !== -1) {
                finalData.phoneCode = user?.phone.split(' ')[0].replace('+', '')
            }
            initialValues.name = `${user?.firstName} ${user?.lastName}`
            initialValues.email = user?.email
            initialValues.phone = phoneNumber
        }
    } catch (err) {
        finalData.carrierOptions = []
    }
    return finalData
}

const ContactUsValidation = {
    issue: yup.string().notOneOf(['-Select-'], 'Issue is required.').required('Issue is required.'),
    description: yup
        .string()
        .matches(/^[^<>/]+$/, '<,>,/ are not allowed.')
        .required('Description is required.'),
    name: yup
        .string()
        .min(1, 'Name is invalid.')
        .max(50, 'Name is invalid.')
        .matches(/^[^<>/]+$/, '<,>,/ are not allowed.')
        .required('Name is required.'),
    phone: yup
        .string()
        .test('phone', 'Phone is invalid.', (value: any) => {
            const numeralValue = value.replace(/\D/g, '')
            return numeralValue.length >= 5 && numeralValue.length <= 18
        })
        .matches(/^[0-9 ()-]+$/, 'Phone is invalid.')
        .required('Phone is required.'),
    email: yup
        .string()
        .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/, 'Email ID is invalid.')
        .email('Email ID is invalid.')
        .required('Email ID is required.')
}

const ContactCarrierValidation = {
    carrier: yup.string().notOneOf(['-Select-'], 'Carrier is required.').required('Carrier is required.')
}

export {ContactRouteLoader, ContactUsValidation, ContactCarrierValidation}
